import React from 'react';
import {
  TextField, Button, CardContent, CardHeader,
} from '@material-ui/core';

import {
  Props,
} from './types';

const ClubOccupancyWidgetCard: React.FC<Props> = (props: Props) => (
  (
    <>
      <CardContent>
        <TextField
          value={props.focusedWidgetData.params.title}
          onChange={(event) => props.handleChangeData('title', event.target.value)}
          autoFocus
          margin="dense"
          id="widgetTitle"
          label="Widget title"
          fullWidth
        />
        <TextField
          value={props.focusedWidgetData.params.description}
          onChange={(event) => props.handleChangeData('description', event.target.value)}
          autoFocus
          margin="dense"
          id="widgetDescription"
          label="Widget Description"
          fullWidth
        />
      </CardContent>
    </>
  )
);

export default ClubOccupancyWidgetCard;
